import type { ReactiveFormSubmitCompletionPolicySnapshot } from './reactive-form-submit-completion-policy';

export interface ReactiveFormSubmitAfterSendCoordinatorConfiguration<TResponse> {
  readonly response: TResponse;
  readonly completion: ReactiveFormSubmitCompletionPolicySnapshot;
  readonly emitAfterSend: (response: TResponse) => void;
  readonly emitGoBack: () => void;
}

/** Runs successful-submit callbacks according to the resolved completion policy. */
export class ReactiveFormSubmitAfterSendCoordinator<TResponse> {
  public complete(
    configuration: ReactiveFormSubmitAfterSendCoordinatorConfiguration<TResponse>,
  ): void {
    if (configuration.completion.shouldEmitAfterSend) {
      configuration.emitAfterSend(configuration.response);
    }

    if (configuration.completion.navigationDecision.shouldNavigateBack) {
      configuration.emitGoBack();
    }
  }
}
